<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Product Codes</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" class="mt-4">
            <v-autocomplete autocomplete="off" dense outlined v-model="selectedCustomer" :items="customers"
              label="Select Customer" item-text="Name" item-value="id" :search-input.sync="searchCustomers"
              @change="getProductCodes(selectedCustomer)"></v-autocomplete>
          </v-col>

          <v-col cols="5">
            <v-file-input class="mt-2" name="productExcelFile" v-model="excelFile" label="Browse Codes Excel Sheet"
              outlined dense></v-file-input>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" @click="uploadExcel">
              <v-icon left>mdi-upload</v-icon>Upload Product Codes
            </v-btn>
          </v-col>
        </v-row>

        <!-- <v-col cols="12" xs="12" sm="12" md="4">
            <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
        </v-col>-->

        <v-row>
          <v-col cols="8">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
              hide-details></v-text-field>
          </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary">

          <v-col cols="8">
            <v-data-table :headers="headers" :items="productCodes" :search="search" :items-per-page="1000">
               <!-- action template -->
               <template v-slot:item.action="{ item }">
                <v-btn @click="openEditModal(item)" color="primary" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <!-- snackbar -->

    <!-- edit modal -->
    <v-dialog v-model="editDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Edit Product Details</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row dense>

              <v-col cols="12" xs="12" md="12">
                <v-text-field autocomplete="off" v-model="editItem.name" label="Product Name"
                  outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" md="6">
                <v-text-field autocomplete="off" v-model="editItem.ItemCode" label="Item Code"
                  outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" md="6">
                <v-text-field v-model="editItem.BarCode" label="Bar Code" outlined
                  dense></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" @click="updateRecord" :loading="loader">
                  <v-icon left>mdi-content-save</v-icon> Update
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal -->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    selectedCustomer: null,
    searchCustomers: null,
    headers: [
      { text: "Default Code", value: "product.ItemCode" },
      { text: "Product Name", value: "name" },
      { text: "Item Code", value: "ItemCode" },
      { text: "Bar Code", value: "BarCode" },
      { text: "Edit", value: "action" }
    ],
    editItem: {},
    editDialog: false,
    customers: [],
    productCodes: [],
    search: "",
    loader: false,
    excelFile: null,
    date: null
  }),
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    openEditModal(data) {
      this.editItem = data;
      this.editDialog = true;
    },
    updateRecord() {
      const self = this;
      const url = "/update-product-code-record";
      const productRecord = this.editItem;
      const data = {
        id: productRecord.id,
        name: productRecord.name,
        ItemCode: productRecord.ItemCode,
        BarCode: productRecord.BarCode
      };

      self.loader = true;

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getProductCodes(self.selectedCustomer);
            self.loader = false;
            self.$refs.snackbar.show("Updated successfully", "green");
            self.editDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
          self.loader = false;
        });
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(myDate) {
      this.date = myDate;
    },
    getProductCodes(id) {
      const self = this;
      this.$store
        .dispatch("get", `/get-product-codes/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.productCodes = res.ResponseData;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    uploadExcel() {
      if (this.selectedCustomer == null || this.selectedCustomer == undefined) {
        this.$refs.snackbar.show("Please select customer", "red");
      }

      var store_id = localStorage.getItem("store_id");
      var subscriber_id = localStorage.getItem("subscriber_id");
      const self = this;
      const data = new FormData();

      data.append("documentData", this.excelFile);
      data.append("store_id", parseInt(store_id));
      data.append("subscriber_id", parseInt(subscriber_id));
      data.append("customer_id", parseInt(self.selectedCustomer));
      this.$store.commit("btnLoader", true);
      const url = "/import-product-codes";
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Products imported successfully", "green");
            self.$store.commit("btnLoader", false);
            self.excelFile = null;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>